import { SplixerResourceInterface } from './splixer-resource.interface';
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  uNumber,
  uString,
  Uuid
} from '@hidat/huijs-common';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerFieldConfigs } from './splixer-fields.const';
import { HashViews } from './hash-views';
import { MixConfigInterface } from './mix-filter.interface';
import { MixPlaybackTypes } from './splixer-types';

export const SessionPathConfig = new ResourceConfig(
  'SessionPath',
  'session_paths',
)
  .addFields(
    [
      splixerFieldConfigs.intId,
      splixerFieldConfigs.status,
      splixerFieldConfigs.instanceId,
      splixerFieldConfigs.contentPathId,
      splixerFieldConfigs.playbackSessionId,
      new FieldConfig('userMixId', FieldDataTypes.INTEGER),
      new FieldConfig('mixMode'),
      new FieldConfig('source'),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.uid,
    new FieldConfig('mixConfig', FieldDataTypes.HASH),
    new FieldConfig('playbackConstraints', FieldDataTypes.HASH),
    new FieldConfig('statistics', FieldDataTypes.HASH),
    new FieldConfig('mixState', FieldDataTypes.HASH),
    new FieldConfig('timeSpent', FieldDataTypes.INTEGER),
  ]);

export interface MixStatistics {
  duration: number;
  valid_segments: number;
  invalid_segments: number;
  available_items?: number;
}

export interface SessionPathState {
  cached: number[];
  fully_scheduled: boolean; // Set to true when we discover we have scheduled all elements (but still have elements to send to the player)
  out_of_content: boolean; // Set to true when we are asked to schedule items and none are available
}

export interface SessionPathInterface extends SplixerResourceInterface<number> {
  uid: Uuid | undefined;
  playbackSessionId: uNumber;
  mixId: uNumber;
  instanceId: uNumber;
  userMixId: uNumber;
  mixMode: uString;
  playbackType: MixPlaybackTypes | undefined;
  playbackConstraints: AnyHash | undefined;
  source: uString;  // source of the play request - for statistics
  duration: uNumber;
  statistics: MixStatistics | undefined;
  mixConfig: MixConfigInterface | undefined;
  mixState: SessionPathState | undefined;
  timeSpent: uNumber;
  tenantId: string | undefined;
}
